import { render } from "./term-condition.vue?vue&type=template&id=38af0098"
import script from "./term-condition.vue?vue&type=script&lang=js"
export * from "./term-condition.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__